import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from '../Icon'
import Spacer from '../Spacer'
import Text from '../Text'

const ClickContainer = styled.button`
    border: 0;
    background: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
    cursor: pointer;
    padding-top: ${({ paddingVertical }) => `${paddingVertical}px`};
    padding-bottom: ${({ paddingVertical }) => `${paddingVertical}px`};
    width: ${({ width }) => ((typeof width === 'string') ? width : `${width}px`)};
    align-self: ${({ alignSelf }) => alignSelf};
`

const ClickIcon = ({
    iconName,
    size,
    labelText,
    width,
    color,
    paddingVertical,
    alignSelf,
    ...rest
}) => (
    <ClickContainer
        width={width}
        paddingVertical={paddingVertical}
        alignSelf={alignSelf}
        {...rest}
    >
        <Icon
            iconName={iconName}
            width={size}
            height={size}
        />
        {labelText !== '' && <Spacer size="S" row />}
        {labelText !== '' && <Text size="XS" color={color}>{labelText}</Text>}
    </ClickContainer>
)

ClickIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
    size: PropTypes.number,
    labelText: PropTypes.string,
    paddingVertical: PropTypes.number,
    alignSelf: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'stretch',
    ]),
    color: PropTypes.oneOf(Text.colors),
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
}

ClickIcon.defaultProps = {
    size: 50,
    labelText: '',
    width: '100%',
    paddingVertical: 12,
    alignSelf: 'stretch', // TODO: check if this is applied in web
    color: 'white',
}

export default ClickIcon
